import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import moment from 'moment';
import { OptionDiv, OptionInput, RowCenter, Row } from './Styles';
import { schedule } from '../../../../../../../assets/base64Images/ai/schedule';
import { lang } from '../../../../../../../lib/utils/utils';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';
import DatetimeModal from '../../DatetimeModal';

const DeliveryTimeInput: FC<Props> = ({
  callback,
  flowId,
}) => {
  const placeholderRef = useRef<any>();
  const [showSelectDatetime, setShowSelectDatetime] = useState<boolean>(false);
  const [y, setY] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (placeholderRef.current) {
        placeholderRef.current.placeholder = lang('Choose time...', '选择时间...');
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <Row>
      {
        showSelectDatetime && (
          <DatetimeModal
            callback={(datetime) => {
              callback(moment(datetime).format('YYYY-MM-DD HH:mm:ss'));
              setShowSelectDatetime(false);
            }}
            y={y}
          />
        )
      }
      <OptionDiv>
        <RowCenter>
          <img src={schedule} style={{ width: 23, height: 23 }} />
          <OptionInput
            onClick={() => {
              if (flowId) {
                // 如果已经点击过一次了，不允许再次触发
                if (TempFieldUtils.aiFlowIds.includes(flowId)) {
                  return;
                }
                TempFieldUtils.aiFlowIds.push(flowId);
              }
              setY(placeholderRef.current.getBoundingClientRect().top || 0);
              setShowSelectDatetime(true);
            }}
            ref={placeholderRef}
            type={'text'}
            readOnly={true}
            style={{ width: 83, height: 23 }}
          />
        </RowCenter>
      </OptionDiv>
    </Row>
  );
};

export interface Props {
  callback: (code: string) => void;
  // 流程ID，同一个流程下，只要触发了一次就加入到流程ID中，避免重复触发
  flowId?: string;
}

export default DeliveryTimeInput;
